import { SVGProps } from 'react';

export default function Arrow(props: Partial<SVGProps<any>>) {
  return (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M12.6663 5.66675L7.99967 10.3334L3.33301 5.66675" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  )
}